import { render, staticRenderFns } from "./CommunicationPropertyListTable.vue?vue&type=template&id=03549104"
import script from "./CommunicationPropertyListTable.vue?vue&type=script&lang=js"
export * from "./CommunicationPropertyListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports